import { render, staticRenderFns } from "./VFooterItem.vue?vue&type=template&id=da26e1e0&"
import script from "./VFooterItem.vue?vue&type=script&lang=js&"
export * from "./VFooterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports